<template>
  <div>
    <cube-popup
      ref="myPopup"
      type="my-popup"
      class="bind-dialog"
      position="center"
    >
      <div class="bind-dialog-box">
        <h2>{{ $t('message["431"]') }} </h2>
        <div class="d-tip-con">
          <template v-if="bindType==='mobile'">
            {{ mergeTelTipTxt[0] }} {{ value }} {{ mergeTelTipTxt[1] }}<br>{{ mergeTelTipTxt[2] }}？
          </template>
          <template v-else-if="bindType==='email'">
            {{ mergeEmailTipTxt[0] }} {{ value }} {{ mergeEmailTipTxt[1] }}<br>{{ mergeEmailTipTxt[2] }}？
          </template>
          <template v-else-if="bindType==='user'">
            {{ mergetTipTxt[0] }} {{ value }} {{ mergetTipTxt[1] }}
          </template>
        </div>

        <div class="bind-d-btn">
          <cube-button
            type="submit"
            :primary="true"
            @click="triggerMerge"
          >
            {{ $t('message["596"]') }}
          </cube-button>
        </div>
        <p>
          <a
            href="javascript:;"
            @click="bindDialogHide"
          >{{ $t('message["64"]') }}</a>
        </p>
      </div>
    </cube-popup>
  </div>
</template>
<script>
import { setAuth } from '@/lib/storage'
import { mapActions, mapState, mapMutations } from 'vuex'
export default {
  components: {
  },
  props: {
    bindType: {
      type: String,
      default: ''
    },
    value: {
      type: String,
      default: ''
    }
    // userid: {
    //   type: Number,
    //   default: 0
    // }
  },
  data () {
    return {
      TipDialogVisible: false,
      submiting: false,
      typeError: 0,
      formData: {}
    }
  },
  computed: {
    ...mapState('account/modify', ['userid']),
    routerName () {
      let name = 'PersonAcount'
      const { bindType } = this
      if (bindType === 'user') {
        name = 'PersonAcount'
      } else if (bindType === 'mobile') {
        name = 'PersonPhone'
      } else if (bindType === 'email') {
        name = 'SetEmail'
      }
      return name
    },
    mergetTipTxt () {
      return this.$t('message["201"]').split('|')
    },
    mergeTelTipTxt () {
      return this.$t('message["1113"]').split('|')
    },
    mergeEmailTipTxt () {
      return this.$t('message["1506"]').split('|')
    }
  },
  mounted () {
  },
  methods: {
    ...mapActions('account/modify', ['mergeUser']),
    ...mapMutations('account/modify', ['setMergeFormDatas']),
    changeLimitDialog (b) {
      this.TipDialogVisible = b
    },
    async triggerMerge (val) {
      const chain = await this.mergeUser()
      chain.params({ binduserid: this.userid })
        .onSuccess(res => {
          this.bindDialogHide()
          setAuth(res.Authorization)
          this.$store.commit('setAuth', res.Authorization, { root: true })
          this.$router.push({ name: 'OrgIndex' })
        })
        .onNetSuccess(raw => {
          const res = raw.data
          if (res.error === 104 || (res.error === 105)) {
            this.typeError = res.error
            this.bindDialogHide()
            this.$emit('showError', res.error)
          } else if (res.error) {
            this.bindDialogHide()
            if (res.error === 115) {
              res.payload.notsame.forEach(item => {
                item[item.key] = item.values[0].value
              })
              this.setMergeFormDatas(res.payload)
              this.$emit('setPage', 3)
              // this.$router.push({ name: this.routerName, query: { page: 3 } })
            } else {
              this.$selefToast({ type: 'error', text: res.message || res.payload[0].message })
            }
          }
        })
        .config({ tip: false, warn: false })
        .fetch()
    },
    showPopup (refId) {
      const component = this.$refs[refId]
      component.show()
    },
    bindDialogHide () {
      this.$refs.myPopup.hide()
    }
  }
}
</script>
<style lang="scss" scoped>
.bind-dialog::v-deep {
  .cube-popup-content {
    width: 90%;
  }
}
.bind-dialog-box {
  width: 100%;
  background: #fff;
  border-radius: 4px;
  padding: 15px;
  h2 {
    font-size: 18px;
    padding: 6px 0 16px;
    text-align: center;
  }
  .d-tip-con {
    line-height: 24px;
    font-size: 14px;
    text-align: center;
    margin-bottom: 24px;
  }
  p {
    font-size: 14px;
    text-align: center;
    padding: 20px 0;
  }
}
</style>
